import PWAInstallButton from "./PWAInstallButton";

export default function Hero({ C, onLogin, onRegister }) {
  return (
    <section style={{
      position: "relative", padding: "96px 20px 80px",
      display: "flex", flexDirection: "column", alignItems: "center",
      textAlign: "center", overflow: "hidden",
    }}>
      <div style={{ position: "absolute", top: -120, right: "-10%", width: 340, height: 340, borderRadius: "50%", background: `${C.primary}14`, filter: "blur(80px)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: -100, left: "-10%", width: 280, height: 280, borderRadius: "50%", background: `${C.blue}10`, filter: "blur(70px)", pointerEvents: "none" }} />

      <div style={{
        width: 88, height: 88, borderRadius: 24, marginBottom: 24,
        background: `linear-gradient(135deg, ${C.primary}, ${C.primaryDark})`,
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: `0 16px 44px ${C.primary}45`, overflow: "hidden",
        animation: "fadeIn 0.6s ease",
      }}>
        <img src="/logo.webp" alt="CuadraAI" style={{ width: 88, height: 88, objectFit: "contain" }} />
      </div>

      <h1 className="cq-hero-title" style={{
        color: C.text, fontWeight: 900, letterSpacing: "-0.03em",
        lineHeight: 1.12, margin: "0 0 14px", maxWidth: 720,
        animation: "fadeIn 0.6s ease 0.05s backwards",
      }}>
        Gestiona tu negocio de forma inteligente con IA
      </h1>

      <p style={{
        color: C.muted, fontSize: 16, lineHeight: 1.6, maxWidth: 540,
        margin: "0 0 36px", animation: "fadeIn 0.6s ease 0.1s backwards",
      }}>
        CuadraAI centraliza tus finanzas, tu inventario y tus ventas en un solo lugar,
        y usa inteligencia artificial para ayudarte a tomar mejores decisiones cada día.
      </p>

      <div style={{
        display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center",
        marginBottom: 22, animation: "fadeIn 0.6s ease 0.15s backwards",
      }}>
        <button onClick={onRegister} style={{
          background: C.primary, color: "#fff", border: "none", borderRadius: 14,
          padding: "14px 26px", fontWeight: 800, fontSize: 14.5, fontFamily: "inherit",
          cursor: "pointer", boxShadow: `0 10px 28px ${C.primary}45`, transition: "all 0.2s",
        }}>
          Crear cuenta
        </button>
        <button onClick={onLogin} style={{
          background: "transparent", color: C.text, border: `1px solid ${C.border}`,
          borderRadius: 14, padding: "14px 26px", fontWeight: 700, fontSize: 14.5,
          fontFamily: "inherit", cursor: "pointer", transition: "all 0.2s",
        }}>
          Iniciar sesión
        </button>
      </div>

      <div style={{ animation: "fadeIn 0.6s ease 0.2s backwards" }}>
        <PWAInstallButton C={C} />
      </div>
    </section>
  );
}
